export default {
    verifyTransunion: 'identity/verify',
    evaluteTransunion: 'transunion/evaluate',
    verifyTransunionFailed: 'transunion/verify/failed',
};
